import { useState } from 'react';
import { FaEnvelope, FaSpinner } from 'react-icons/fa'; 
import styles from '../SignIn.module.css';

const RecuperarContrasena = () => { 
    const [correo, setCorreo] = useState('');
    const [error, setError] = useState('');
    const [enviado, setEnviado] = useState(false); 
    const [cargando, setCargando] = useState(false);

    const validarEmail = (email) => { 
        if (!email) return 'Ingresa tu correo electrónico'; 

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(email)) { 
            return 'El correo electrónico no es válido'; 
        }
        return ''; 
    }; 

    const handleSubmit = (e) => { 
        e.preventDefault(); 

        const errorValidacion = validarEmail(correo); 
        if(errorValidacion) { 
            setError(errorValidacion); 
            return; 
        }
        setCargando(true); 
        setError(''); 

        fetch(`${process.env.REACT_APP_API_URL}/auth/recuperar-contrasena`, {
            method: 'POST', 
            headers: { 
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ correo }), 
        })
        .then(response => {
            return response.text();
        })
        .then(text => {
            try {
                const data = JSON.parse(text);
                setEnviado(true);
            } catch (e) {
                console.error('Error al parsear JSON:', e);
                setError('Error en la respuesta del servidor');
            }
        })
        .catch(error => { 
            console.error('Error en la solicitud:', error);
            setError('No se pudo procesar tu solicitud. Verifica que el correo exista en nuestro sistema.'); 
            setCargando(false);
        });
    };

    if (enviado) {
        return (
            <div className={styles.loginCuerpo}>
                <div className={styles.loginCuadro}>
                    <h1 className={styles.cambiarCon}>Correo Enviado</h1>
                    <div>
                        <FaEnvelope className={styles.iconoCorreo}/>
                        <p>
                            Si el correo <strong>{correo}</strong> está registrado en nuestro sistema, 
                            recibirás un enlace para restablecer tu contraseña.
                        </p>
                        <p>
                            Revisa tu bandeja de entrada y la carpeta de spam.
                        </p>
                        <div className={styles.volverLink}>
                            <a href="/signin">Volver a iniciar sesión</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.loginCuerpo}>
            <div className={styles.loginCuadro}>
                <h1 className={styles.cambiarCon}>Recuperar Contraseña</h1>
                <p>
                    Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
                </p>
                
                {error && (
                    <div className={styles.mensajeError}>
                        {error}
                    </div>
                )}
                
                <form onSubmit={handleSubmit} className={styles.loginForm}>
                    <div className={styles.campoLogin}>
                        <label htmlFor="correo">
                            <FaEnvelope className={styles.iconoInput} />
                            Correo electrónico:
                        </label>
                        <input
                            type="email"
                            id="correo"
                            className={styles.inputLogin}
                            value={correo}
                            onChange={(e) => {
                                setCorreo(e.target.value);
                                if (error) setError('');
                            }}
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        className={styles.botonLogin}
                        disabled={cargando}
                    >
                        {cargando ? (
                            <>
                                <FaSpinner className={styles.spinner}/> {' '}
                                Enviando...
                            </>
                        ) : (
                            'Enviar enlace de recuperación'
                        )}
                    </button>
                </form>
                
                <div className={styles.volverLink}>
                    <a href="/signin">Volver a iniciar sesión</a>
                </div>
            </div>
        </div>
    );
};

export default RecuperarContrasena;